export const steps = ['Business Detail', 'Contact Detail', 'Other Details'];
